/**
 * 公車地圖標籤避讓：先試偏移，仍重疊才隱藏。
 */

export const LABEL_SHIFT_CANDIDATES = [
    { dx: 0, dy: 0 },
    { dx: 0, dy: -24 },
    { dx: 28, dy: 0 },
    { dx: -28, dy: 0 },
    { dx: 0, dy: 24 },
    { dx: 30, dy: -18 },
    { dx: -30, dy: -18 }
];

export function boxesOverlap(a, b, pad = 3) {
    return !(
        a.right + pad <= b.left ||
        a.left - pad >= b.right ||
        a.bottom + pad <= b.top ||
        a.top - pad >= b.bottom
    );
}

/**
 * @param {{ left: number, top: number, width: number, height: number }[]} boxes
 * @returns {{ dx: number, dy: number, hidden: boolean }[]}
 */
export function assignLabelShifts(boxes, opts = {}) {
    const pad = opts.pad ?? 3;
    const candidates = opts.candidates || LABEL_SHIFT_CANDIDATES;
    const ordered = boxes.map((b, i) => ({ ...b, i })).sort((a, b) => {
        const dy = a.top - b.top;
        if (dy) return dy;
        return a.left - b.left;
    });
    const placed = [];
    const result = boxes.map(() => ({ dx: 0, dy: 0, hidden: true }));

    for (const box of ordered) {
        const w = box.width || 0;
        const h = box.height || 0;
        if (w < 2 || h < 2) {
            result[box.i] = { dx: 0, dy: 0, hidden: true };
            continue;
        }
        let chosen = null;
        for (const c of candidates) {
            const trial = {
                left: box.left + c.dx,
                top: box.top + c.dy,
                right: box.left + c.dx + w,
                bottom: box.top + c.dy + h
            };
            if (!placed.some((p) => boxesOverlap(trial, p, pad))) {
                chosen = { ...c, rect: trial };
                break;
            }
        }
        if (chosen) {
            result[box.i] = { dx: chosen.dx, dy: chosen.dy, hidden: false };
            placed.push(chosen.rect);
        }
    }
    return result;
}
